<template>
  <div class="cmi00310-wrapper">
    <PageHeaderBanner>
      <template #title>承認設定</template>
    </PageHeaderBanner>
    <div class="cmi00310-form-area cmi00310-form">
      <MessageChip :display="isMessageChip" level="E" :message="errMessage" />

      <!-- 会員情報表示 -->
      <MemberDetailCard :data="mKaiinInfo" mode="memberapproval" />
      <!-- 入力欄 -->
      <q-form autofocus greedy novalidate @submit="checkInputForm()" @validation-error="resetError">
        <div class="cmi00310-input-area q-gutter-y-sm">
          <div class="row q-gutter-x-md" :class="[!input && 'display']">
            <div :class="[input ? 'col' : 'col-3 text-right q-mr-md'] + ' code'">
              <label :class="inputData.approval_stat === '1' && input ? 'requier' : ''"
                >得意先コード</label
              >
              <CustomerSelects
                v-if="input"
                :customer="inputData.customer_cd === null ? '' : inputData.customer_cd"
                lazy-rules
                @selected="inputData.customer_cd = $event"
                @keydown.enter.prevent
              />
            </div>
            <div v-if="!input" class="col">
              <span> {{ inputData.customer_cd }}</span>
            </div>
          </div>
          <div class="row q-gutter-x-md" :class="[!input && 'display']">
            <div :class="'email ' + [input ? 'col q-pt-md' : 'col-3 text-right q-mr-md']">
              <label :class="inputData.approval_stat === '1' && input ? 'requier' : ''"
                >見積依頼メ－ルアドレス1</label
              >
              <q-input
                v-if="input"
                v-model="inputData.quote_request_mail1"
                outlined
                dense
                maxlength="254"
                class="input-area left-input"
                :rules="[
                  (val: string) => !isEmpty(val) || isValidateEmail(val) || $t('validation.email'),
                ]"
                lazy-rules
                @keydown.enter.prevent
              />
            </div>
            <div v-if="!input" class="col" style="word-break: break-all">
              <span>{{ inputData.quote_request_mail1 }}</span>
            </div>
          </div>
          <div class="row q-gutter-x-md" :class="[!input && 'display']">
            <div :class="'email ' + [input ? 'col' : 'col-3 text-right q-mr-md']">
              <label>見積依頼メ－ルアドレス2</label>
              <q-input
                v-if="input"
                v-model="inputData.quote_request_mail2"
                outlined
                dense
                maxlength="254"
                class="input-area left-input"
                :rules="[(val: string) => !isEmpty(val) || isValidateEmail(val) || $t('validation.email')]"
                lazy-rules
                @keydown.enter.prevent
              />
            </div>
            <div v-if="!input" class="col" style="word-break: break-all">
              <span>{{ inputData.quote_request_mail2 }}</span>
            </div>
          </div>
          <div class="row q-gutter-x-md" :class="[!input && 'display']">
            <div :class="'email ' + [input ? 'col' : 'col-3 text-right q-mr-md']">
              <label>見積依頼メ－ルアドレス3</label>
              <q-input
                v-if="input"
                v-model="inputData.quote_request_mail3"
                outlined
                dense
                maxlength="254"
                class="input-area left-input"
                :rules="[(val: string) => !isEmpty(val) || isValidateEmail(val) || $t('validation.email')]"
                lazy-rules
                @keydown.enter.prevent
              />
            </div>
            <div v-if="!input" class="col" style="word-break: break-all">
              <span>{{ inputData.quote_request_mail3 }}</span>
            </div>
          </div>
          <div class="row q-gutter-x-md" :class="[!input && 'display']">
            <div :class="'email ' + [input ? 'col' : 'col-3 text-right q-mr-md']">
              <label>見積依頼メ－ルアドレス4</label>
              <q-input
                v-if="input"
                v-model="inputData.quote_request_mail4"
                outlined
                dense
                maxlength="254"
                class="input-area left-input"
                :rules="[(val: string) => !isEmpty(val) || isValidateEmail(val) || $t('validation.email')]"
                lazy-rules
                @keydown.enter.prevent
              />
            </div>
            <div v-if="!input" class="col" style="word-break: break-all">
              <span>{{ inputData.quote_request_mail4 }}</span>
            </div>
          </div>
          <div class="row q-gutter-x-md" :class="[!input && 'display']">
            <div :class="'approve-setting ' + [input ? 'col q-pb-md' : 'col-3 text-right q-mr-md']">
              <label>ユーザー権限</label>
            </div>
            <div v-if="!input" class="col">
              <span>一般ユーザー</span>
            </div>
          </div>
          <div v-if="input" class="row q-mb-none q-ma-none">
            <span>一般ユーザー</span>
          </div>
          <div class="row q-gutter-x-md" :class="[!input && 'display']">
            <div :class="'approve-setting ' + [input ? 'col q-pt-md' : 'col-3 text-right q-mr-md']">
              <label>会員登録承認</label>
              <div v-if="input" class="q-gutter-sm">
                <q-radio v-model="inputData.approval_stat" val="1" label="承認する" />
                <q-radio v-model="inputData.approval_stat" val="0" label="承認しない" />
              </div>
            </div>
            <div v-if="!input" class="col">
              <span class="q-ma-none">{{
                inputData.approval_stat === '0' ? '承認しない' : '承認する'
              }}</span>
            </div>
          </div>
          <div class="row q-gutter-x-md" :class="[!input && 'display']">
            <div :class="'approve-setting ' + [input ? 'col q-pt-md' : 'col-3 text-right q-mr-md']">
              <label>注文可・不可設定</label>
              <div v-if="input" class="q-gutter-sm">
                <q-radio v-model="inputData.user_order_flg" val="0" label="注文可" />
                <q-radio v-model="inputData.user_order_flg" val="1" label="注文不可" />
              </div>
            </div>
            <div v-if="!input" class="col">
              <span class="q-ma-none">{{
                inputData.user_order_flg === '1' ? '注文不可' : '注文可'
              }}</span>
            </div>
          </div>
          <FormFooterBanner style="position: inherit">
            <template #button-area>
              <div v-if="input">
                <q-btn
                  outline
                  class="q-mr-xs"
                  style="color: var(--q-delete); width: 120px"
                  label="戻る"
                  @click="router.replace({ name: 'members' })"
                />
                <q-btn
                  v-model="input"
                  color="primary"
                  type="chenge"
                  style="width: 120px"
                  label="内容確認"
                />
              </div>
              <div v-if="!input">
                <q-btn
                  v-model="input"
                  color="primary"
                  outline
                  class="q-mr-xs"
                  style="width: 120px"
                  icon="mdi-chevron-left"
                  label="前へ"
                  @click="prev"
                />
                <q-btn
                  color="primary"
                  style="width: 120px"
                  label="設定"
                  @click="isConfirmationFlag = true"
                />
              </div>
            </template>
          </FormFooterBanner>
          <AlertDialog
            :display="isConfirmationFlag"
            level="information"
            title="更新確認"
            :text="['入力された内容で更新します。', 'よろしいですか？']"
            @confirm="(isConfirmationFlag = false), updateMemberInfo()"
            @close="isConfirmationFlag = false"
          />
          <AlertDialog
            :display="regist"
            level="information"
            confirmation
            title="承認設定完了"
            :text="['会員情報の変更が完了しました。']"
            @complete="(regist = false), returnMembers()"
          />
        </div>
      </q-form>
    </div>
  </div>
</template>

<script setup lang="ts">
import { reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import { Loading } from 'quasar';
import axios from 'axios';
import AlertDialog from '../../components/dialogs/AlertDialog.vue';
import MemberDetailCard from '../../components/card/MemberDetailCard.vue';
import FormFooterBanner from '../../components/banner/FormFooterBanner.vue';
import PageHeaderBanner from '../../components/banner/PageHeaderBanner.vue';
import CustomerSelects from '../../components/selects/CustomerSelects.vue';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import MessageChip from '../../components/chip/MessageChip.vue';
import { isEmpty, isValidateEmail } from '../../common/utils/validateUtils';
import DetailResultStatusCode from '../../common/code/DetailResultStatusCode';
import messages from '../../messages/message.json';

const router = useRouter();

interface Props {
  userId: string;
}
const props = defineProps<Props>();
// 会員情報
const mKaiinInfo = ref({
  approval_stat: '',
  auth_level: '',
  user_id: '',
  user_name_mei: '',
  user_name_sei: '',
  customer_cd: '',
  mail_address: '',
  phone_number: '',
  work_school_name: '',
  affiliation_department_name: '',
  postal_cd: '',
  todohuken_name: '',
  street_address: '',
  quote_request_mail1: '',
  quote_request_mail2: '',
  quote_request_mail3: '',
  quote_request_mail4: '',
  update_timestamp: '',
  user_attribute: '',
});

// 入力値
const inputData = reactive({
  customer_cd: '',
  quote_request_mail1: '',
  quote_request_mail2: '',
  quote_request_mail3: '',
  quote_request_mail4: '',
  approval_stat: '',
  default_approval_stat: '',
  user_order_flg: '',
});
const input = ref(true);

// 更新確認ダイアログ
const isConfirmationFlag = ref(false);

// 更新完了ダイアログ
const regist = ref(false);

// 変更内容確認画面表示切り替え
const confirmation = () => {
  input.value = false;
};
// 確認画面から入力画面に戻る
const prev = () => {
  input.value = true;
};

// エラーメッセージ
const errMessage = ref('');

// エラーメッセージチップフラグ
const isMessageChip = ref(false);

// 入力内容エラーフラグ
const errorFlag = ref(false);

/**
 * エラーチップを初期化
 */
const resetError = async () => {
  errMessage.value = '';
  isMessageChip.value = false;
};

/**
 * 会員情報取得
 */
const getMemberInfo = async () => {
  // Loading Start
  Loading.show();

  const user_id = props.userId;
  const formData = new FormData();
  formData.append('user_id', user_id);
  // 会員情報取得
  await axios
    .post('/cmi003101/memberInfo', formData)
    .then((res) => {
      const { common } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          mKaiinInfo.value = res.data.mkaiin;

          inputData.customer_cd = res.data.mkaiin.customer_cd;
          inputData.quote_request_mail1 = res.data.mkaiin.quote_request_mail1;
          inputData.quote_request_mail2 = res.data.mkaiin.quote_request_mail2;
          inputData.quote_request_mail3 = res.data.mkaiin.quote_request_mail3;
          inputData.quote_request_mail4 = res.data.mkaiin.quote_request_mail4;
          inputData.approval_stat = res.data.mkaiin.approval_stat;
          inputData.default_approval_stat = res.data.mkaiin.approval_stat;
          inputData.user_order_flg = res.data.mkaiin.order_flg;

          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          router.push({ name: 'error' });

          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.res.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 *  会員情報の更新
 */
const updateMemberInfo = async () => {
  // Loading Start
  Loading.show();

  errMessage.value = '';
  isMessageChip.value = false;

  // 変更データ作成
  const formData = new FormData();
  formData.append('customer_cd', inputData.customer_cd === null ? '' : inputData.customer_cd);
  formData.append(
    'quote_request_mail1',
    inputData.quote_request_mail1 === null ? '' : inputData.quote_request_mail1
  );
  formData.append(
    'quote_request_mail2',
    inputData.quote_request_mail2 === null ? '' : inputData.quote_request_mail2
  );
  formData.append(
    'quote_request_mail3',
    inputData.quote_request_mail3 === null ? '' : inputData.quote_request_mail3
  );
  formData.append(
    'quote_request_mail4',
    inputData.quote_request_mail4 === null ? '' : inputData.quote_request_mail4
  );
  formData.append('user_order_flg', inputData.user_order_flg);
  formData.append('approval_stat', inputData.approval_stat);
  formData.append('default_approval_stat', inputData.default_approval_stat);
  formData.append('user_id', props.userId);
  formData.append('mail_address', mKaiinInfo.value.mail_address);
  await axios
    .post('/cmi003101/member/approve', formData)
    .then((res) => {
      const { common } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // ダイアログの表示
          regist.value = true;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            case DetailResultStatusCode.UPDATE_ERROR:
              // エラーメッセージ表示
              errMessage.value = common.message;
              isMessageChip.value = true;
              break;

            // システムエラーの場合
            case DetailResultStatusCode.SYSTEM_ERROR:
              router.push({ name: 'error' });
              break;
            default:
              router.push({ name: 'error' });
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.res.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};
/**
 * 変更内容確認（入力チェック）
 *
 */
const checkInputForm = async () => {
  // エラーフラグのリセット
  errMessage.value = '';
  isMessageChip.value = false;
  errorFlag.value = false;
  // 見積依頼メールアドレス重複チェック
  if (
    inputData.quote_request_mail3 !== null &&
    inputData.quote_request_mail3 !== '' &&
    inputData.quote_request_mail3 === inputData.quote_request_mail4
  ) {
    errMessage.value = messages.ja.message.MSG_50072E;
    isMessageChip.value = true;
    errorFlag.value = true;
  }
  // 見積依頼メールアドレス重複チェック
  if (
    inputData.quote_request_mail2 !== null &&
    inputData.quote_request_mail2 !== '' &&
    (inputData.quote_request_mail2 === inputData.quote_request_mail3 ||
      inputData.quote_request_mail2 === inputData.quote_request_mail4)
  ) {
    errMessage.value = messages.ja.message.MSG_50072E;
    isMessageChip.value = true;
    errorFlag.value = true;
  }
  // 見積依頼メールアドレス重複チェック
  if (
    inputData.quote_request_mail1 !== null &&
    inputData.quote_request_mail1 !== '' &&
    (inputData.quote_request_mail1 === inputData.quote_request_mail2 ||
      inputData.quote_request_mail1 === inputData.quote_request_mail3 ||
      inputData.quote_request_mail1 === inputData.quote_request_mail4)
  ) {
    errMessage.value = messages.ja.message.MSG_50072E;
    isMessageChip.value = true;
    errorFlag.value = true;
  }
  // 画面．入力_見積依頼メールアドレス３が未入力 且つ 画面．入力_見積依頼メールアドレス４が入力済みの場合エラー
  if (
    (inputData.quote_request_mail3 === null || inputData.quote_request_mail3 === '') &&
    inputData.quote_request_mail4 !== null &&
    inputData.quote_request_mail4 !== ''
  ) {
    errMessage.value = messages.ja.message.MSG_50059E;
    isMessageChip.value = true;
    errorFlag.value = true;
  }
  // 画面．入力_見積依頼メールアドレス２が未入力 且つ 画面．入力_見積依頼メールアドレス３か３４が入力済みの場合エラー
  if (
    (inputData.quote_request_mail2 === null || inputData.quote_request_mail2 === '') &&
    ((inputData.quote_request_mail3 !== null && inputData.quote_request_mail3 !== '') ||
      (inputData.quote_request_mail4 !== null && inputData.quote_request_mail4 !== ''))
  ) {
    errMessage.value = messages.ja.message.MSG_50059E;
    isMessageChip.value = true;
    errorFlag.value = true;
  }
  // 画面．入力_見積依頼メールアドレス２が未入力 且つ 画面．入力_見積依頼メールアドレス３か３４が入力済みの場合エラー
  if (
    (inputData.quote_request_mail1 === null || inputData.quote_request_mail1 === '') &&
    ((inputData.quote_request_mail2 !== null && inputData.quote_request_mail2 !== '') ||
      (inputData.quote_request_mail3 !== null && inputData.quote_request_mail3 !== '') ||
      (inputData.quote_request_mail4 !== null && inputData.quote_request_mail4 !== ''))
  ) {
    errMessage.value = messages.ja.message.MSG_50059E;
    isMessageChip.value = true;
    errorFlag.value = true;
  }

  // 画面．入力_承認ステータス＝承認済み 且つ 画面．入力_見積依頼メールアドレス１が未入力の場合エラー
  if (
    inputData.approval_stat === '1' &&
    (inputData.quote_request_mail1 === null || inputData.quote_request_mail1 === '')
  ) {
    errMessage.value = messages.ja.message.MSG_50074E;
    isMessageChip.value = true;
    errorFlag.value = true;
  }

  // 画面．入力_承認ステータス＝承認済み 且つ 画面．得意先コードが未入力の場合エラー
  if (
    inputData.approval_stat === '1' &&
    (inputData.customer_cd === '' || inputData.customer_cd === null)
  ) {
    errMessage.value = messages.ja.message.MSG_50075E;
    isMessageChip.value = true;
    errorFlag.value = true;
  }
  window.scrollTo({ top: 0 });
  if (!errorFlag.value) {
    // 変更内容確認表示
    confirmation();
  }
};

// 会員一覧への遷移
const returnMembers = async () => {
  router.replace({ name: 'members' });
};
/**
 * 初期表示処理
 */
// propsが存在しない場合
if (!props.userId) {
  // 前画面に遷移
  returnMembers();
} else {
  getMemberInfo();
}
</script>
<style scoped>
.cmi00310-form-area {
  width: 80%;
  max-width: 1020px;
  margin: 0 auto;
}
.cmi00310-input-area {
  width: 80%;
  margin: 30px auto 0;
}

.approve-setting,
.email,
.code {
  margin-left: 0;
}
</style>
<style>
.cmi00310-wrapper .message-chip .q-chip {
  margin-bottom: 8px;
}
</style>
